import { render } from "./detail_script.vue?vue&type=template&id=7e2ad17c&scoped=true"
import script from "./detail_script.vue?vue&type=script&lang=js"
export * from "./detail_script.vue?vue&type=script&lang=js"

import "./detail_script.vue?vue&type=style&index=0&id=7e2ad17c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e2ad17c"]])

export default __exports__